// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flow-modal{background:rgba(0,0,0,.5);position:fixed;top:0;left:0;z-index:1050;height:100%;width:100%;overflow-y:scroll;display:flex;align-items:center;justify-content:center}", ""]);
// Exports
module.exports = exports;
